import { FC } from 'react';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';

import { useUploadAssetsContext } from '../contexts/UploadAssetsContext';
import { DropZoneArea } from '../types';

const DropZoneContainer = styled.div`
  border: none;
  box-sizing: border-box;
  flex: 1 0 auto;
  position: relative;
  :focus {
    outline: none;
  } /** disables the focus outline */
`;

export const testIds = {
  dropZone: 'cl-drop-zone',
};

export type Props = {
  area: DropZoneArea;
  isDisabled?: boolean;
};

export const DropZone: FC<React.PropsWithChildren<Props>> = ({
  area,
  children,
  isDisabled = false,
}) => {
  const { handleNewFiles, setActiveDropZone } = useUploadAssetsContext();

  // file(s) dropped onto the target area: accept, multiple, minSize, and maxSize are not defined
  // in useDropzone, so all files will be accepted (our validation is handled in handleNewFiles)
  const onDrop = (acceptedFiles: File[]) => {
    setActiveDropZone(DropZoneArea.None);
    handleNewFiles(acceptedFiles);
  };

  const { getRootProps } = useDropzone({
    disabled: isDisabled,
    noClick: true,
    onDrop,
    onDragEnter: () => setActiveDropZone(area),
    onDragLeave: () => setActiveDropZone(DropZoneArea.None),
  });

  return (
    <DropZoneContainer data-test={testIds.dropZone} {...getRootProps({})}>
      {children}
    </DropZoneContainer>
  );
};

export default DropZone;
